import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit } from '@angular/core';
import { isInsideEditor } from '@dotcms/client';
import { DotCmsFacade } from 'src/app/extensions/dot-cms/facades/dot-cms.facade';
import { CustomDotCmsContentlet } from 'src/app/extensions/dot-cms/models/contentlet/custom-dotcms-contentlet.model';
import { isInsideCarousel } from 'src/app/extensions/dot-cms/utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-blog-post',
  templateUrl: './dot-cms-blog-post.component.html',
  styleUrls: ['./dot-cms-blog-post.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsBlogPostComponent implements OnInit {
  @Input() contentlet: CustomDotCmsContentlet;
  @Input() identifier: string;
  isInCarousel: boolean;
  isExpanded = false;
  shouldShowReadMore = false;
  isInSideEditor: boolean;
  constructor(private dotCmsFacade: DotCmsFacade, private elementRef: ElementRef) {}
  ngOnInit(): void {
    this.isInCarousel = isInsideCarousel(this.elementRef.nativeElement);
    this.isInSideEditor = isInsideEditor();
    this.checksTeaserLength();
  }
  buildImageSrc(imageKey: string) {
    return this.dotCmsFacade.generateImageURIFromImageKey(this.identifier, imageKey);
  }
  getTags(tagString: string): string[] {
    if (tagString) {
      return tagString.split(',');
    }
  }
  toggleContent(event: Event) {
    event.preventDefault();
    this.isExpanded = !this.isExpanded;
  }

  checksTeaserLength() {
    if (this.contentlet?.teaser && this.contentlet?.teaser.length > 0) {
      const maxLines = 3;
      const maxCharsPerLine = 60;
      const maxChars = maxLines * maxCharsPerLine;
      if (this.contentlet?.teaser.length > maxChars) {
        this.shouldShowReadMore = true;
      }
    }
  }
}
